import React from "react";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import { useGlobalStyles } from "./globalStyles";
import { IconButton, Tooltip } from "@material-ui/core";

const ICON_MAP = {
  edit: EditIcon,
  delete: DeleteIcon,
};

const IconRendererRHF = ({ icons = [] }) => {
  const classes = useGlobalStyles();
  return (
    <div className={classes.flexAlignCenter}>
      {icons.map((icon, idx) => {
        const IconComponent = ICON_MAP[icon.name.toLowerCase()];
        if (!IconComponent) return null;

        return (
          <Tooltip key={idx} title={icon.tooltipText} placement="top">
            <IconButton size="small">
              <IconComponent
                key={idx}
                onClick={icon.onClick}
                className={classes.cursorPointer}
              />
            </IconButton>
          </Tooltip>
        );
      })}
    </div>
  );
};

export default IconRendererRHF;
